import { render, staticRenderFns } from "./SelectFaculties.vue?vue&type=template&id=7930983d&scoped=true&"
import script from "./SelectFaculties.vue?vue&type=script&lang=js&"
export * from "./SelectFaculties.vue?vue&type=script&lang=js&"
import style0 from "./SelectFaculties.vue?vue&type=style&index=0&id=7930983d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7930983d",
  null
  
)

export default component.exports